import { render, staticRenderFns } from "./ProjectsTypes.vue?vue&type=template&id=0fa42292&scoped=true"
import script from "./ProjectsTypes.vue?vue&type=script&lang=js"
export * from "./ProjectsTypes.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTypes.vue?vue&type=style&index=0&id=0fa42292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa42292",
  null
  
)

export default component.exports